import ImageCollection from './ImageCollection'
import Location from './Location'

export default class Event {
  id = undefined
  title = undefined
  slug = undefined
  content = undefined
  start_date = undefined
  end_date = undefined
  tag = undefined
  raw = undefined

  /**
   *
   * @type {ImageCollection}
   */
  imgs = new ImageCollection();

  /**
   * @type Location
   */
  location = undefined

  constructor (source = undefined) {
    this.raw = source
    if(source) {
      this.parseSource(source)
    }
  }

  parseSource (source) {
    for (const prop in source) {
      if(prop in this) {
        this[prop] = source[prop]
      }
    }
    if (source.afbeelding) {
      this.imgs = new ImageCollection(source.afbeelding)
    }
    const location = new Location(source)
    if(location.isValid()) {
      this.location = location
    }

  }

}
